/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from 'react';
import { Paper, Typography } from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import type { PRCurveData } from '../../../types';

interface Props {
  data: PRCurveData;
  title?: string;
}

export default function PRCurve({ data, title = 'Precision-Recall Curve' }: Props) {
  const chartData = data.recall.map((recall, i) => ({
    recall: Math.round(recall * 1000) / 1000,
    precision: Math.round(data.precision[i] * 1000) / 1000,
  }));

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="subtitle2" gutterBottom>
        {title}
      </Typography>
      <ResponsiveContainer width="100%" height={280}>
        <LineChart data={chartData} margin={{ top: 5, right: 20, bottom: 25, left: 10 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="recall"
            type="number"
            domain={[0, 1]}
            label={{ value: 'Recall', position: 'bottom', offset: 10 }}
          />
          <YAxis
            type="number"
            domain={[0, 1]}
            label={{ value: 'Precision', angle: -90, position: 'insideLeft' }}
          />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="precision"
            stroke="#2e7d32"
            strokeWidth={2}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </Paper>
  );
}
